import React, {useEffect,useState} from 'react'
import {Button,Text,Spinner } from 'grommet';
import { DocumentDownload } from 'grommet-icons';
import {Storage} from 'aws-amplify';


function GetShipmentDocuments(props){
    const [docs, setDocs] = useState();
    const [documentPresent, setDocumentPresent] = useState(false)
    const [docsLoaded, setDocsLoaded] = useState(false)
    const [awbDocUrl, setAwbDocUrl] = useState()
    const [ciDocUrl, setCIDocUrl] = useState()
    const isDocumentPresent = (key) => {
        if (key === ""){
            return false
        } else {
            setDocumentPresent(true)
            return true
        }
    }

    useEffect(() => {
        if (isDocumentPresent(props.shipment.documents_key)){
            Storage.list("shipments/" + props.shipment.documents_key) 
            .then(result => {
                var docsArr = result
                docsArr.map(res => {
                    if(res.key.includes("AWB")){
                        Storage.get(res.key).then(url => {
                            setAwbDocUrl(url)
                         })
                    } else {
                        Storage.get(res.key).then(url => {
                            setCIDocUrl(url)
                         })
                    }
                    return res
                })
                setDocs(result)
                setDocsLoaded(true)
            })
            .catch(err => console.log(err));
           
        }
      }, [props.shipment.documents_key]);
      let view;
      if (documentPresent && docsLoaded){
          if (docs.length > 0){
            view = (
                <div>
                <a rel="noopener noreferrer" target="_blank" href={awbDocUrl}><Button margin="small" icon={<DocumentDownload color='status-ok'/>} label={docs[0].key.split("/")[2]} type='button'/></a>
                <a rel="noopener noreferrer" target="_blank" href={ciDocUrl}><Button margin="small" icon={<DocumentDownload color='status-ok'/>} label={docs[1].key.split("/")[2]} type='button'/></a>
                </div>
            )
          } else {
              view = <Text>No Documents Available</Text>
          }
          } else {
            view = <Spinner />
          } 
      return view
}

export default GetShipmentDocuments
